import modelExtend from 'dva-model-extend';

import { setState } from 'services/state';
import { model } from './common';


export default modelExtend(model, {
  namespace: 'state',

  effects: {

    * setState({ payload, output }, { call }) {
      const data = yield call(setState, payload);
      if (output) output.value = data;
      if (!data.success) throw data;
    },

  },
});



// WEBPACK FOOTER //
// ./src/models/state.js